import {html, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {FeatureDetector} from "../../../common/featureDetector";
import {resolve} from "../../../container";
import {HorizontalOverflowService} from "../horizontalOverflow";
import type {Nullable} from "../../../bootstrap/common/types";
import {UnLitElement} from "../../../common/elements";

@customElement("eop-swipe-hint")
export class EopSwipeHint extends UnLitElement {

    @property({attribute: "size"})
    private size: string;
    @property({type: Boolean, reflect: true})
    public active: boolean;

    public constructor(
        private features: FeatureDetector = resolve(FeatureDetector),
        private horizontalOverflowService: HorizontalOverflowService = resolve(HorizontalOverflowService)
    ) {
        super();
        this.size = "small";
        this.active = false;
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.horizontalOverflowService.registerHandler(this, overflown => this.active = overflown);
    }

    public disconnectedCallback(): void {
        this.horizontalOverflowService.unregisterHandler(this);
        super.disconnectedCallback();
    }

    public render(): Nullable<TemplateResult> {
        if (!this.features.isTouchDevice()) {
            return null;
        }

        const hintType = "swipe-hint-" + this.size;
        return html`
            <div class=swipe-hint-box>
                <eop-already-in-viewport percentage=0.8 class="swipe-hint ${hintType}">
                    <eop-svg-sprite-icon icon-id="swipehint"></eop-svg-sprite-icon>
                </eop-already-in-viewport>
            </div>`;
    }
}